import { render, staticRenderFns } from "./damageItemPhotoclaim.pug?vue&type=template&id=4944b6bf&lang=pug&external"
import script from "./damageItemPhotoclaim.js?vue&type=script&lang=js&external"
export * from "./damageItemPhotoclaim.js?vue&type=script&lang=js&external"
import style0 from "./damageItemPhotoclaim.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4944b6bf')) {
      api.createRecord('4944b6bf', component.options)
    } else {
      api.reload('4944b6bf', component.options)
    }
    module.hot.accept("./damageItemPhotoclaim.pug?vue&type=template&id=4944b6bf&lang=pug&external", function () {
      api.rerender('4944b6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damageItemPhotoclaim/index.vue"
export default component.exports